import * as React from 'react';
import { AvatarBase } from 'wix-ui-tpa/cssVars';
import type { AvatarBaseProps } from 'wix-ui-tpa/cssVars';
import classNames from 'clsx';
import type { IWutAvatarProps } from '../WutAvatar.props';
import { TestIds } from '../constants';
import { st, classes } from './style/WutAvatar.component.st.css';

const getName = (firstName: string, lastName: string): string => {
  let name = lastName || '';

  if (firstName) {
    name = lastName ? `${firstName} ${lastName}` : firstName;
  }

  return name;
};

// This type is for supporting previewMapper passing the textType prop
type TextType = { textType: AvatarBaseProps['textType'] };

const WutAvatar: React.FC<IWutAvatarProps & TextType> = props => {
  const { id, firstName, lastName, src, onMouseEnter, onMouseLeave, textType } =
    props;
  const { className, stylableClassName } = props as any; // todo: remove it once this prop would be added for the lean

  return (
    <div
      id={id}
      className={classNames(className, classes.avatarWrapper)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <AvatarBase
        textType={textType}
        lettersLimit={2}
        className={st(classes.root, stylableClassName)}
        data-hook={TestIds.baseAvatar}
        name={getName(firstName, lastName)}
        src={src}
      />
    </div>
  );
};

export default WutAvatar;
